var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"title":_vm.autoFeedTooltipMessage,"variant":_vm.autoFeedVariantProp,"data-cy":"auto-feed-button"},on:{"click":function($event){return _vm.toggleAutoFeed()}}},[_c('span',[_c('i',{staticClass:"far fa-infinity fa-lg"})])])}
var staticRenderFns = []

export { render, staticRenderFns }